<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">
                <ol class="breadcrumb noprint">
                    <li>
                        <a href="#/">
                            <i class="fa fa-home" aria-hidden="true"></i> INICIAL
                        </a>
                    </li>
                    <li class="active"> <i class="fa fa-suitcase" aria-hidden="true"></i> CONTRATOS DE FIBRA SEM CAIXA CADASTRADA</li>
                </ol>
                <div class="row">
                    <div class="col-md-12">
                        <list-contratos-sem-caixa/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ListContratosSemCaixa } from "../../components/exports";

export default {
    components: {
        ListContratosSemCaixa
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
